module.exports = __webpack_public_path__ + "static/media/CTLI_10-235w.3e9c8e00.jpg";